import { render, staticRenderFns } from "./AdminOptions.vue?vue&type=template&id=0d4211b4&"
import script from "./AdminOptions.vue?vue&type=script&lang=js&"
export * from "./AdminOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports